import { API } from '@/api';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const createSpo = createAsyncThunk(
  'spo/createSpo',
  async ({ objective, region }: { objective: string; region: string }) =>
    API.spos.createSpo({ objective, region }),
);

export const retrieveSpo = createAsyncThunk('chat/getSpo', async ({ jobId }: { jobId: string }) =>
  API.spos.getSpo({ jobId }),
);
